import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduce } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { fetchTVProductMappings } from '../../../Setup/SetupActions';
import { getTVProductDictionary, getTVUseProductMappings } from '../../../Setup/SetupReducer';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';


class EnsureTVProductMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchData() {
    this.setState({ loading: true });
    this.props.dispatch(fetchTVProductMappings())
      .then(
        () => {
          if (this.mounted) {
            this.setState({ loading: false });
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false });
          }
        },
      );
  }
  
  render() {
    const {
      hasSetup, canSetup, location,
      children, products,
    } = this.props;
    const { loading } = this.state;

    const alert = (
      <div className="alert alert-warning">
        {canSetup &&
          <div>
            Please setup <Link to={`/setup/truvoice-products?r=${location.pathname}`}>TruVoice Program Products</Link> before using this feature.
          </div>
        }
        {!canSetup &&
          <div>
            <p>Please note that your organization needs to set up the <strong>TruVoice Program Products</strong> before using this feature.</p>
            <p>Contact a TruSales&trade; manager for your organization to have them complete the setup process.</p>
          </div>
        }
      </div>
    );
    return children(loading, hasSetup, products, alert);
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const products = getTVProductDictionary(state);
  const tvUseProductMappings = getTVUseProductMappings(state);
  let hasSetup = false;

  if (tvUseProductMappings) {
    reduce(products, (items, tvProducts, productId) => {
      items[productId] = reduce(tvProducts, (subItems, tvProduct) => {
        if (tvProduct.program_type === ownProps.programType && tvProduct.program_id === ownProps.programId) {
          hasSetup = true;
          subItems.push(tvProduct);
        }
        return subItems;
      }, []);
      return items;
    }, {});
  }

  hasSetup = true; // optional! https://github.com/lumen-software/TruSales/issues/1130
  return {
    hasSetup,
    products,
    canSetup: getCanSetupOrganization(state),
  };
}

EnsureTVProductMapping.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  programType: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  children: PropTypes.func,
  products: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
  hasSetup: PropTypes.bool.isRequired,
  canSetup: PropTypes.bool.isRequired,
};

EnsureTVProductMapping.defaultProps = {
  products: {},
  children: () => null,
};

EnsureTVProductMapping.contextTypes = {
};

export default withRouter(connect(mapStateToProps)(EnsureTVProductMapping));
